export default "__VITE_ASSET__Do4DmrG2__"